import * as React from 'react';
import ProjectInterestedCardComponent, { ProjectInterestedCardComponentProps } from './ProjectInterestedCard.component';
import Person from 'src/entities/Person';

interface Props {
  interestedUser: Person;
}

class ProjectInterestedCardContainer extends React.Component<Props> {

  constructor(props: Props) {
    super(props);
    this.state = {};
  }

  public render(): React.ReactNode {
    return (
      <ProjectInterestedCardComponent {...this.getComponentProps()}/>
    );
  }

  private getComponentProps(): ProjectInterestedCardComponentProps {
    return {
      interestedUser: this.props.interestedUser,
      profilePicture: undefined,
    };
  }
}

export default ProjectInterestedCardContainer;


// WEBPACK FOOTER //
// ./src/modules/project/partials/project-interested/ProjectInterestedCard.container.tsx